"use client";

import Image from "next/image";
import React from "react";

const FilosofiLogoCard = ({ image, title, description, ref }) => {
  return (
    <div ref={ref} className={`flex flex-col md:flex-row gap-5 sm:gap-10 md:gap-20 justify-between md:justify-center items-center h-full md:h-80 w-[80vw] lg:w-[900px] p-3 sm:p-5 md:p-10 bg-white rounded-xl drop-shadow-md hover:drop-shadow-lg transition-all duration-300`}>
      <div className="flex justify-center items-center p-5 md:p-0 h-full md:h-52 w-auto">
        <Image
          src={image}
          className="w-full h-full object-contain"
          alt="image"
          width={0}
          height={0}
          sizes="100%"
        />
      </div>
      <div className="flex flex-col w-full md:w-1/2 gap-2 md:gap-5 justify-center items-center text-justify">
        <div className="text-cust-blue font-semibold text-left w-full text-xl sm:text-2xl md:text-3xl lg:text-4xl">
          {title}
        </div>
        <div className="font-light leading-tight text-cust-black text-sm sm:text-base md:text-lg">{description}</div>
      </div>
    </div>
  );
};

export default FilosofiLogoCard;
